<template>
	<div class="ms-combobox flex ms-editor">
		<div
			:class="['icon-margin-left', 'mi-new-v2', iconLeft]"
			v-if="iconLeft"
		></div>
		<input
			ref="input"
			class="input"
			:placeholder="placeholder"
			v-model="internalText"
			v-on="listeners"
			:disabled="disabled"
			:maxlength="maxLength"
			:class="[
				{ disabled: disabled },
				isInputPlaceHolder ? 'input-placeholder-over' : '',
			]"
			:readonly="readonly"
			@click="onClickInput"
		/>
		<div
			:class="['icon-input', 'mi-new-v2', icon]"
			v-if="icon"
			@click="handleClickIcon"
		></div>
		<div
			v-if="hasIconClearText && hasInternalText"
			:class="[
				'item-icon',
				'mi-new-v2',
				'mi-16',
				iconClear || 'mi-icon-v2-delete-16',
				'mr-2',
				'cursor-pointer',
			]"
			@click.stop="clearText"
		></div>
		<ms-combo-box-dropdown
			ref="dropdownPanel"
			v-if="expanded && !hideDropdown"
			:topx="dropdownTopx"
			:leftx="dropdownLeftx"
			:maxWidthx="dropdownMaxWidthx"
			:minWidthx="dropdownMinWidthx"
			:columnx="columns"
			:comboType="comboType"
			:emptyText="null"
			:class="[
				{
					'combobox-dropdown-custom': isCustomComboxOrg,
					'combobox-not-data':
						!internalDataSourceFilter || internalDataSourceFilter.length <= 0,
				},
			]"
		>
			<MsRecycleScroller
				ref="scroller"
				:style="styleScroller"
				:items="internalDataSourceFilter"
				:itemSize="itemSize"
				:keyField="keyField"
				:emitUpdate="true"
				:buffer="0"
				:visiableIndex="typeAheadPointer"
				@visible="onScrollerVisible"
				@update="onScrollerUpdate"
				:itemSizeCustom="45"
			>
				<template v-slot="{ item, index }">
					<ms-combo-box-item
						:comboType="comboType"
						:item="item"
						:columnx="columns"
						:valueField="valueField"
						:displayField="displayField"
						:class="[
							{
								'ms-combobox-item--highlight': typeAheadPointer == index,
							},
							{ 'ms-combobox-item-custom': isCustomComboxOrg },
						]"
						@click.stop="onItemClick(item, $event)"
						:align="alignCombobox"
						:indexItem="index"
					></ms-combo-box-item>
				</template>
			</MsRecycleScroller>
		</ms-combo-box-dropdown>
	</div>
</template>
<script>
import MsComboBoxDropdown from '@/components/mscombobox/MsComboBoxDropdown.vue';
import MsComboBoxItem from '@/components/mscombobox/MsComboBoxItem.vue';
import MsRecycleScroller from '@/components/msvirtualscroller/MsRecycleScroller';
import commonFunc from '@/common/commonFunction.js';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
export default {
	name: 'msInputSearchAutoComplete',
	extends: msBaseComponent,
	components: { MsComboBoxDropdown, MsRecycleScroller, MsComboBoxItem },
	inheritAttrs: false,
	props: {
		value: {},
		placeholder: {
			default: null,
			type: [Number, String],
		},
		maxItemsDisplay: {
			default: 5,
			type: Number,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		/**
		 * Trường làm value
		 * CreatedBy LTDAT 15.06.2020
		 */
		valueField: {
			type: String,
			default: 'id',
		},
		/**
		 * Trường làm text display
		 * CreatedBy LTDAT 15.06.2020
		 */
		displayField: {
			type: String,
			default: 'value',
		},
		//Dữ liệu của combobox
		data: {
			default: () => [],
			type: Array,
		},
		// //Độ rộng của 1 item
		itemSizeP: {
			default: 36,
			type: Number,
		},
		//Chỉ nhận giá trị có trong danh sách
		forceSelection: {
			default: true,
			type: Boolean,
		},
		//Là combotree hay không
		isComboTree: {
			default: false,
			type: Boolean,
		},
		//Parent Field
		idProperty: {
			default: null,
			type: String,
		},
		//Field chứa parentID
		parentIdProperty: {
			default: 'ParentID',
			type: String,
		},
		//Không cho phép chọn trường là cha
		notSelectionParent: {
			default: false,
			type: Boolean,
		},
		//Độ rông của dropdown tính bằng px
		dropdownWidth: {
			default: null,
			type: [String, Number],
		},
		//Store xử lý dữ liệu trên liên quan đến data trong grid
		store: {
			default: null,
		},
		//Mode query lấy dữ liệu từ server hay client
		queryMode: {
			type: String,
			default: 'remote',
		},
		remoteFilter: {
			type: Boolean,
			default: false,
		},
		//Trạng thái có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Combo mặc định chọn bản ghi theo index
		initIndex: {
			default: -1,
			type: Number,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		autoLoad: {
			default: false,
			type: Boolean,
		},
		display: {},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		mappingField: {
			default: null,
		},
		firstExpandLoad: {
			default: false,
			type: Boolean,
		},
		keyField: {
			default: '__vKeyValue',
			type: String,
		},
		maxLength: {
			default: null,
			type: Number,
		},
		readonly: {
			default: false,
			type: Boolean,
		},
		isInputPlaceHolder: {
			default: false,
			type: Boolean,
		},
		// cho phếp bổ sung class để style lại combo
		// Sử dụng cho TH style đặc biệt
		styleCombo: {
			default: '',
			type: String,
		},
		alignCombobox: {
			default: 'left',
			type: String,
		},
		autoMappingValue: {
			default: false,
			type: Boolean,
		},
		//Custom lại combobox cho chi nhánh hình cây
		isCustomComboxOrg: {
			type: Boolean,
			default: false,
		},
		// Không cho phép set dữ liệu item click hay không
		// Phục vụ daterange dashboard
		unAllowSetItemClick: {
			type: Boolean,
			default: false,
		},
		keyData: {
			type: String,
			default: '',
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		iconLeft: {
			default: null,
			type: String,
		},
		iconSize: {
			default: 'mi-24',
			typeof: String,
		},
		hasIconClearText: {
			default: false,
			type: Boolean,
		},
		// Class icon clear text, mặc định dùng icon delete cũ
		iconClear: {
			default: null,
			type: String,
		},
		// Ẩn dropdown gợi ý — dùng như input search thường (phục vụ popup MoveInvoice)
		hideDropdown: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		listeners() {
			const me = this;
			return {
				input: (event) => me.onInput(event),
				focus: (event) => me.onFocus(event),
				change: (event) => me.onChange(event),
				blur: (event) => me.onBlur(event),
				keydown: (event) => me.onKeydown(event),
			};
		},
		hasInternalText() {
			const me = this;
			return me.internalText != null && me.internalText != '' ? true : false;
		},
		itemSize() {
			return this.itemSizeP;
		},
		//Tính độ rộng của dropdown combobox để scroll
		styleScroller() {
			const me = this;
			return { 'max-height': me.maxItemsDisplay * me.itemSize + 'px' };
		},
		internalDataSourceFilter() {
			const me = this;
			let searchText = me.getQueryString();
			if (
				!searchText ||
				!me.internalDataSource ||
				me.internalDataSource.length <= 0
			) {
				me.typeAheadPointer = -1;
				return me.internalDataSource;
			}

			let data = me.internalDataSource.filter(
				(x) =>
					x[me.displayField] &&
					x[me.displayField].toLowerCase().includes(searchText.toLowerCase())
			);
			if (!data || data.length <= 0) me.typeAheadPointer = -1;
			return data;
		},
	},
	data() {
		const me = this;
		me.initStaticData();
		return {
			internalDataSource: [],
			internalText: null,
			expanded: false,
			dropdownTopx: 0,
			dropdownLeftx: 0,
			internalSelectedItem: null,
			internalSelectedItemBefore: null,
			typeAheadPointer: -1,
			focused: false,
		};
	},
	//Hàm khởi tạo dữ liệu hook func
	async created() {
		const me = this;
		me.initCombo();
		me.setInitIndex();
		me.initData();
		if (me.autoLoad) {
			me.doQueryInternal(null, false);
		}

		if (me.mappingField) {
			for (let key in me.mappingField) {
				me.$options.propsData[key] = null;
			}
		}
		EventBusGlobal.$on(GlobalEventName.scrollEvent, me.scrollEvent);
	},
	beforeDestroy() {
		const me = this;
		me.expand(false);
		if (me.$refs.dropdownPanel) {
			me.$refs.dropdownPanel.$el.remove();
		}
		document.removeEventListener('mousedown', me.click_out);
		EventBusGlobal.$off(GlobalEventName.scrollEvent, me.scrollEvent);
	},
	mounted() {
		const me = this;
		//Debounce query để delay load
		if (me.queryMode != 'remote') {
			me.internalQueryDelay = 20;
		}
		me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
		if (me.store) {
			me.store.pageAppend = true;
		}
	},
	methods: {
		clearText() {
			const me = this;
			if (!me.hasIconClearText) return;
			me.internalText = '';
			me.internalValue = null;
			me.$emit('input', '');
			me.$emit('change', '');
		},
		/**
		 * Bắt sự kiện khi scroll trên chương trình thì đóng combobox lại
		 * Created by LTDAT
		 */
		scrollEvent(e) {
			const me = this;
			if (me.expanded) {
				this.expand(false);
			}
		},
		/**
		 * Mặc định chọn giá trị theo index ban đầu
		 * Created by LTDAT
		 */
		setInitIndex() {
			const me = this;
			if (
				me.initIndex >= 0 &&
				me.internalDataSource &&
				me.internalDataSource.length > 0 &&
				me.typeAheadPointer < 0
			) {
				me.typeAheadPointer = me.initIndex;
				me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
			}
		},
		/**
		 * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
		 * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
		 * @param start: vị trí bắt đầu của view trong vitual scroll
		 * @param end: vị trí kết thúc của view trong vitual scroll
		 * Created by LTDAT(30.06.2020)
		 *  */
		onScrollerUpdate(start, end) {
			const me = this;
			if (me.pagination) {
				if (
					end == me.internalDataSource.length &&
					end < me.pageTotal &&
					start == me.internalDataSource.length - 5
				) {
					let payload = {
						Skip: me.internalDataSource.length,
						Take: me.internalDataSource.length + 20,
						pageAppend: true,
					};
					me.$emit('loadData', payload);
				}
			}
		},
		/**
		 * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
		 * CreatedBy LTDAT 11/12/2019
		 */
		doQueryInternal(searchString, expand = true) {
			let me = this,
				event = { preventDefault: false, sender: me },
				queryString = searchString != null ? searchString : me.getQueryString();
			me.$emit('beforeQuery', event);
			if (event.preventDefault) {
				return false;
			}
			if (me.lastQueryString == queryString) {
				me.expand(expand);
			} else {
				me.lastQueryString = queryString;
				me.querying = true;
				me.typeAheadPointer = -1;
				if (me.queryMode === 'remote') {
					me.doRemoteQuery(queryString).then((x) => {
						commonFunc.genVKeyValue(me.internalDataSource);
						me.afterQuery(expand);
					});
				} else {
					me.doLocalQuery(queryString).then((x) => me.afterQuery(expand));
				}
			}
		},
		/**
		 * Xử lý sau khi query xong dữ liệu
		 * CreatedBy LTDAT 24.06.2020
		 */
		afterQuery(expand) {
			const me = this;
			me.expand(expand);
		},
		/**
		 * Query dữ liệu api
		 * CreatedBy LTDAT 24.06.2020
		 */
		doRemoteQuery(queryString, expand) {
			//Build filter,
			let me = this,
				filters = [],
				filterFields = me.filterFields;
			return new Promise((resolve, reject) => {
				if (queryString) {
					for (const key in filterFields) {
						if (filterFields.hasOwnProperty(key)) {
							const f = filterFields[key];
							let filter = {
								property: key,
								value: queryString,
								operator: f,
								operand: 'or',
							};
							filters.push(filter);
						}
					}
				}
				let payload = {};
				if (me.pagination) {
					payload.Skip = 0;
					payload.Take = 20;
					payload.pageAppend = false;
				}
				me.$emit('loadData', payload);
			});
		},
		/**
		 * Query dữ liệu local
		 * CreatedBy LTDAT 24.06.2020
		 */
		doLocalQuery(queryString) {
			let me = this,
				store = me.store;

			return new Promise((resolve, reject) => {
				//Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
				let p;
				if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
					let proxy = store.proxy;
					if (proxy && proxy.type === 'cache') {
						p = store.load();
					}
				}
				p ? p.then(resolve, reject) : resolve(false);
			}).then(() => {
				me.loading = false;
			});
		},
		/**
		 * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
		 * CreatedBy LTDAT 11/12/2019
		 */
		getQueryString() {
			return (this.internalText || '').trim();
		},
		//Click ra ngoài combo đóng combo lại
		//Created by LTDAT 18.06.2020
		click_out(e) {
			const me = this;
			const target = e && e.target;
			if (!target) return;

			//Dropdown được teleport ra body (MsComboBoxDropdown.insertBody) nên không
			//nằm trong me.$el, phải check riêng. Ref có thể undefined khi hideDropdown = true
			//hoặc trong khe render giữa expand(true) và lúc dropdown mount xong.
			const dropdownEl = me.$refs.dropdownPanel && me.$refs.dropdownPanel.$el;
			const insideInput = me.$el && me.$ms.commonFunc.hasParent(target, me.$el);
			const insideDropdown =
				dropdownEl && me.$ms.commonFunc.hasParent(target, dropdownEl);

			//Click trong combo thì giữ mở
			if (insideInput || insideDropdown) {
				return;
			}
			me.expand(false);
		},
		//Reset lại các giá trị trong combobox
		reset() {
			const me = this;
			me.internalText = '';
			me.internalSelectedItem = null;
			me.typeAheadPointer = -1;
			me.internalValue = null;
			me.$emit('input', me.internalValue);
		},
		/**
		 * Set giá trị hiển thị
		 * @pram value giá trị hiển thị
		 */
		setInternalText(value) {
			const me = this;
			me.internalText = value;
		},
		/**
		 * Set value cho combo
		 */
		setValue(value) {
			const me = this;
			me.internalValue = value;
			me.$emit('input', me.internalValue);
			if (me.typeAheadPointer >= 0) {
				me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
			}
		},
		//Created by LTDAT (16.06.2020)
		onInput(e) {
			const me = this;
			if (!me.expanded) {
				me.expand(true);
			}
			me.$emit('input', me.internalText);
		},

		onClickInput() {
			const me = this;
			if (!me.expanded) {
				me.expand(true);
			}
		},
		//Sự kiện focus vào input
		onFocus(e) {
			const me = this;
			me.focused = true;
			if (!me.expanded) {
				me.expand(true);
			}
		},
		//Sự kiện change input
		onChange(e) {
			const me = this;
		},
		//Sự kiện blur input
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
			// me.validate(me.internalText);
		},
		//Sự kiện keydown input
		onKeydown(e) {
			const me = this;
			switch (e.which) {
				case 40:
					{
						if (!me.expanded) {
							me.expand(true);
						} else if (me.typeAheadPointer < me.getTotalData() - 1) {
							if (me.notSelectionParent) {
								let typeAheadPointerNext = me.typeAheadPointer + 1;
								for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
									me.typeAheadPointer++;
									me.adjustScroll(typeAheadPointerNext);
									if (!me.internalDataSource[i].isParent) {
										break;
									}
								}
							} else {
								me.typeAheadPointer++;
								me.adjustScroll();
							}
						}
					}
					break;
				case 38:
					{
						if (me.expanded) {
							if (me.typeAheadPointer > 0) {
								if (me.notSelectionParent) {
									let typeAheadPointerPre = me.typeAheadPointer - 1;
									for (let i = typeAheadPointerPre; i > 0; i--) {
										me.typeAheadPointer--;
										me.adjustScroll(me.typeAheadPointer);
										if (!me.internalDataSource[i].isParent) {
											break;
										}
									}
								} else {
									me.typeAheadPointer--;
									me.adjustScroll();
								}
							}
						}
					}
					break;
				case 13:
					{
						let obj = {};
						if (me.typeAheadPointer >= 0) {
							obj[`${me.valueField}`] = me.$ms.commonFunc.generateUUID();
							obj[`${me.displayField}`] = me.internalDataSourceFilter[
								me.typeAheadPointer
							]
								? me.internalDataSourceFilter[me.typeAheadPointer][
										me.displayField
								  ]
								: '';
						} else if (me.internalText) {
							//Chưa tồn tại gợi ý complete thì thêm vào storage
							obj[`${me.valueField}`] = me.$ms.commonFunc.generateUUID();
							obj[`${me.displayField}`] = me.internalText.trim();
						}

						me.changeData(obj);
					}
					break;
			}
			me.$emit('keydown', event);
		},
		//Lấy tổng số lượng dữ liệu trong data
		getTotalData() {
			const me = this;
			return me.internalDataSource.length;
		},
		//Tìm kiếm item trong list
		//Created by LTDAT(16.06.2020)
		filterIndexItemByText(queryText) {
			const me = this;
			let filters = me.filterFields,
				value = queryText || me.internalText,
				index = -1;
			if (filters) {
				index = me.internalDataSource.findIndex((item, _index) => {
					let ret = false;
					for (const key in filters) {
						if (filters.hasOwnProperty(key)) {
							const s = filters[key];
							if (s == 'contains') {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.contains(value.toLowerCase());
							} else {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.startsWith(value.toLowerCase());
							}
							if (ret) {
								break;
							}
						}
					}
					return ret;
				});
			}
			return index;
		},
		//Lấy cột filter để tìm kiếm local
		//Created by LTDAT 16.06.2020
		getFilterFields() {
			let filter = {};

			if (this.columns && this.columns.length > 0) {
				for (let i = 0; i < this.columns.length; i++) {
					const col = this.columns[i];
					if (!col.filterOperator) {
						col.filterOperator = 'contains';
					}
					if (col.dataField && col.filterOperator) {
						if (this.filterColumns && this.filterColumns.length > 0) {
							this.filterColumns.forEach((e) => {
								if (!filter.hasOwnProperty(e)) {
									filter[e] = col.filterOperator;
								}
							});
						} else {
							filter[col.dataField] = col.filterOperator;
						}
					}
				}
			} else {
				filter[this.displayField] = 'contains';
			}
			return filter;
		},
		//Lấy element scroll
		//Created by LTDAT (16.06.2020)
		getScroller() {
			if (this.expanded) {
				return this.$refs['scroller'];
			}
			return null;
		},
		/**
		 * Di chuyển view đến bản ghi nếu cần
		 * @param {Bản ghi cần view} index
		 * CreatedBy LTDAT 16.06.2020
		 */
		adjustScroll(typeAheadPointer = this.typeAheadPointer) {
			let scroller = this.getScroller();
			if (scroller) {
				scroller.scrollToItem(typeAheadPointer, true);
			}
		},
		onScrollerVisible() {
			const me = this;
			me.adjustScroll();
		},

		/**
		 * Click item dropdown
		 */
		onItemClick(item, event) {
			const me = this;
			if (!item) return;
			me.changeData(item);
		},

		changeData(item) {
			const me = this;
			// Reset datasource trước để MsRecycleScroller render 0 items,
			// tránh lỗi vdom insertBefore khi unmount scroller
			me.expand(false);
			me.$nextTick(() => {
				me.addToDataSourceStorage(item);
				me.setInternalItem(item);
				me.$emit('input', me.internalText);
				me.$emit('change', me.internalText);
			});
		},

		//Set giá trị được chọn
		setInternalItem(item, userAction = true) {
			const me = this;
			if (item) {
				me.internalValue = item[me.valueField];
				me.internalText = item[me.displayField];
				me.typeAheadPointer = -1;
			}
		},

		//Khởi tạo dữ liệu tĩnh mặc định
		initStaticData() {
			const me = this;
			me.comboType = 1;

			me.internalQueryDelay = 200;
			me.filterFields = me.getFilterFields();
			me.internalValue = null;
			me.firstExpand = true;
		},

		//Khởi tạo dữ liệu
		initData() {
			const me = this;
			me.setDataSource();
		},

		setDataSource() {
			const me = this;
			me.internalDataSource = me.getDataSourceStorageByKey(me.keyData);
			commonFunc.genVKeyValue(me.internalDataSource);
		},

		initCombo() {
			const me = this;
			if (me.isComboTree) {
				me.comboType = 3;
			} else if (me.columns && me.columns.length !== 0) {
				me.comboType = 2;
			} else {
				me.comboType = 1;
			}
		},
		//Đóng mở combobox
		expand(mode = !this.expanded) {
			const me = this;
			if (me.firstExpand) {
				if ((me.queryMode == 'remote' && !me.autoLoad) || me.firstExpandLoad) {
					me.doQueryInternal(null, true);
				}
				me.firstExpand = false;
			}
			if (mode == true) {
				me.$emit('beforeExpand');
				document.addEventListener('mousedown', me.click_out);
				me.$refs.input.focus();
				me.changeDropdownPosition();
			} else {
				document.removeEventListener('mousedown', me.click_out);
			}
			me.expanded = mode;
		},
		/**
		 * Hàm set vị trí cho dropdown menu khi expand
		 * TODO: Chưa xử lý khi có scroll
		 */
		changeDropdownPosition() {
			let me = this,
				comboEl = me.$el,
				comboElRect = comboEl.getBoundingClientRect(),
				comboMenuEl = me.$el;

			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;

			me.dropdownLeftx = comboElRect.left;
			me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
			me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
				? me.dropdownWidth
				: comboElRect.width;

			// Nếu chạm phải thì align sang trái
			if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
				me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
			}

			// Nếu chạm bottom thì align top
			let maxItemsDisplay = me.maxItemsDisplay;
			if (me.columns && me.columns.length > 0) {
				maxItemsDisplay += 1;
			}
			if (
				comboElRect.bottom + me.itemSize * maxItemsDisplay + 2 >
				windowHeight
			) {
				me.dropdownTopx =
					comboElRect.top -
					(me.itemSize *
						Math.min(maxItemsDisplay, me.internalDataSource.length) +
						4);
			}
		},

		getDataSourceStorage() {
			const me = this;
			const keyDataSource = 'AutoComplete';
			let dataStorage = localStorage.getItem(keyDataSource);
			dataStorage = !dataStorage ? {} : JSON.parse(dataStorage);
			if (!dataStorage) return {};
			return dataStorage;
		},

		getDataSourceStorageByKey(key) {
			const me = this;
			let data = me.getDataSourceStorage();
			if (!key) return data;
			return data[`${key}`] ? data[`${key}`] : [];
		},

		addToDataSourceStorage(data) {
			const me = this;
			if (
				!data ||
				!data[me.displayField] ||
				(data[me.displayField] && !data[me.displayField].trim())
			)
				return;
			let dataReources = me.getDataSourceStorage();
			let dataList = dataReources[`${me.keyData}`];

			//Chưa có dữ liệu gì
			if (!dataList || dataList.length <= 0) {
				dataList = [];
			}

			//Loại bỏ giá trị tồn tại trước đó
			let index = dataList.findIndex(
				(x) =>
					x[me.displayField] &&
					data[me.displayField] &&
					x[me.displayField].trim() == data[me.displayField].trim()
			);
			if (index >= 0) {
				dataList.splice(index, 1);
			}

			//Kiểm tra xem đã vượt ngưỡng config chưa
			dataList.unshift(data);
			if (
				window.__env.authConfig &&
				dataList.length > window.__env.authConfig.MaximumElementAutoComplete
			) {
				dataList.splice(dataList.length - 1, 1);
			}

			if (!dataReources[me.keyData]) {
				dataReources[me.keyData] = [];
			}
			dataReources[me.keyData] = dataList;
			localStorage.setItem('AutoComplete', JSON.stringify(dataReources));

			//Update dataasource
			me.setDataSource();
		},

		handleClickIcon() {
			this.$emit('handleClickIcon');
		},
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msCombo.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msCombo.scss';
}
.combobox-dropdown-custom {
	padding: 10px;
}
.ms-combobox-item-custom {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}
.custom-input-org {
	flex: 1;
	cursor: pointer;
	overflow: hidden;
}
.cusor-mouse {
	cursor: pointer;
}
.custom-input-header {
	font-weight: 600;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
}
.input.hidden-width {
	width: 0px !important;
}
.custom-input-email {
	color: var(--color-primary);
}
.hidden-box {
	display: none;
}

.combobox-not-data {
	border: none !important;
}
</style>
